import "./Carousel.css";
import { motion } from "framer-motion";
import { useEffect } from "react";

function Carousel()
{
    useEffect(() => {
        console.log(window.outerWidth, window.outerHeight)
    })

    return(
        <div className = "carousel_container">
            <motion.div className = "carousel"
                        initial = {{ x : '0%', y : '0%' }}
                        animate = {{ x : ['0vw', '0vw', '-100vw', '-100vw', '-200vw', '-200vw', '0vw'], y : '0%' }}
                        transition = {{ duration : 10, times : [0, 0.2, 0.3, 0.5, 0.6, 0.8, 1] }}>
                <img src = "/Resources/Carousel_Image_01.png" alt = "err" />
                <img src = "/Resources/Carousel_Image_02.jpg" alt = "err" />
                <img src = "/Resources/Carousel_Image_03.jpg" alt = "err" />
            </motion.div>
            <div className = "slider_control">
                <motion.div className = "control"
                            animate = {{ opacity : ['100%', '100%', '25%', '25%', '25%', '25%', '100%'] }}
                            transition = {{ duration : 10, times : [0, 0.3, 0.4, 0.5, 0.6, 0.95, 1] }}
                >
                </motion.div>
                <div className = "spacer" ></div>
                <motion.div className = "control"
                            animate = {{ opacity : ['25%', '25%', '25%', '100%', '100%', '25%', '25%'] }}
                            transition = {{ duration : 10, times : [0, 0.2, 0.3, 0.5, 0.7, 0.8, 1] }}
                >
                </motion.div>
                <div className = "spacer" ></div>
                <motion.div className = "control"
                            animate = {{ opacity : ['25%', '25%', '25%', '25%', '100%', '100%', '25%'] }}
                            transition = {{ duration : 10, times : [0, 0.2, 0.3, 0.7, 0.8, 0.9, 1] }}
                >
                </motion.div>
            </div>
        </div>
    );
}

export default Carousel;